module.exports = __webpack_public_path__ + "img/sch1-gift1-img.267c5570.png";